<div>
  <div class="filter-container">
    <div class="row">
      <div class="col-2">
        <div class="filter-item-date" style="padding-left: 5%;">
          <div class="filter-item-label">{{'' | i18n: 'user-dealer'}}:</div>
          <select #select [(ngModel)]="filter.dealerNumber" (change)="refreshList()">
            <option value="null">{{'' | i18n: 'select'}}</option>
            @for (dealer of dealerName; track dealer) {
              <option value={{dealer.dealerNumber}}>{{dealer.dealerName}}</option>
            }
          </select>
        </div>
      </div>
      <div class="col-2">
        <div class="filter-item-date" style="padding-left: 1%;">
          <div class="filter-item-label">{{'' | i18n: 'warranty-name'}}:</div>
          <select [(ngModel)]="filter.contractTypeId" (change)="refreshList()">
            <option value="null">{{'' | i18n: 'select'}}</option>
            @for (c of contractTypes; track c) {
              <option value={{c.contractType}}>{{c.contractType}}</option>
            }
          </select>
        </div>
      </div>
      <div class="col-4 date-main pl-3 mr-0 pr-0">
        <div class="date-box">
          <div class="filter-item-date" style="padding-left: 0.1%;">
            <div class="filter-item-label">{{'' | i18n: 'invoice-date'}}:</div>
            <input id="toDates" [(ngModel)]="filter.fromDate" type="date" name="toDate" (change)="refreshList()">
          </div>
        </div>
        <div class="filter-to">
          <div class="filter-item-label" style="visibility: hidden;">..</div>
          {{'' | i18n: 'to'}}
        </div>
        <div class="date-box pl-0">
          <div class="filter-item-date" style="padding-left: 0.1%;">
            <div class="filter-item-label" style="visibility: hidden;">..</div>
            <input id="toDates1" [(ngModel)]="filter.toDate" type="date" name="toDate" (change)="refreshList()">
          </div>
        </div>
      </div>

      <div class="col-4 pl-0 ml-0">
        <div class="filter-item-date pl-0 ml-0">
          <div class="filter-item-label" style="visibility: hidden;">..</div>
          <button class="button cross-btn ml-3" (click)="clearFilter()"><i class="fa fa-times" aria-hidden="true"></i>
        </button>
        <button id="refresh" (click)="refreshList()" class="button search-btnn ml-3">
          {{'' | i18n: 'search'}}
        </button>

        <button id="export" (click)="exportAsXLSX()" class="button search-btnn ml-2">
          {{'' | i18n: 'export'}}
        </button>
      </div>
    </div>
  </div>
  <div class="row mt-4" style="padding-left: 2%;">
    <div class="col-8 row age-group">
      <div class="col-4 row date-main pl-0 mr-0 pr-2">
        <div class="filter-item-label col-12 pl-0">{{'' | i18n: 'age-range'}} 1:</div>
        <div class="dates-box">
          <div class="filter-item-date" style="padding-left: 0.1%;">

            <select #select [(ngModel)]="age1from" (change)="selectAge()">
              <option value="null">{{'' | i18n: 'select'}}</option>
              @for (dealer of range; track dealer) {
                <option value={{dealer}}>{{dealer}}</option>
              }
            </select>
          </div>
        </div>
        <div class="filters-to">
          {{'' | i18n: 'to'}}
        </div>
        <div class="dates-box pl-0">
          <div class="filter-item-date" style="padding-left: 0.1%;">
            <select #select [(ngModel)]="age1to" (change)="selectAge()">
              <option value="null">{{'' | i18n: 'select'}}</option>
              @for (dealer of range; track dealer) {
                <option value={{dealer}}>{{dealer}}</option>
              }
            </select>
          </div>
        </div>

      </div>
      <div class="col-4 row date-main pl-2 mr-0 pr-2">
        <div class="filter-item-label col-12 pl-0">{{'' | i18n: 'age-range'}} 2:</div>
        <div class="dates-box">
          <div class="filter-item-date" style="padding-left: 0.1%;">
            <select #select [(ngModel)]="age2from" (change)="selectAge()">
              <option value="null">{{'' | i18n: 'select'}}</option>
              @for (dealer of range; track dealer) {
                <option value={{dealer}}>{{dealer}}</option>
              }
            </select>
          </div>
        </div>
        <div class="filters-to">
          {{'' | i18n: 'to'}}
        </div>
        <div class="dates-box pl-0">
          <div class="filter-item-date" style="padding-left: 0.1%;">
            <select #select [(ngModel)]="age2to" (change)="selectAge()">
              <option value="null">{{'' | i18n: 'select'}}</option>
              @for (dealer of range; track dealer) {
                <option value={{dealer}}>{{dealer}}</option>
              }
            </select>
          </div>
        </div>

      </div>
      <div class="col-4 row date-main pl-3 mr-0 pr-0">
        <div class="filter-item-label col-12 pl-0">{{'' | i18n: 'age-range'}} 3:</div>
        <div class="dates-box">
          <div class="filter-item-date">
            <select #select [(ngModel)]="age3from" (change)="selectAge()">
              <option value="null">{{'' | i18n: 'select'}}</option>
              @for (dealer of range; track dealer) {
                <option value={{dealer}}>{{dealer}}</option>
              }
            </select>
          </div>
        </div>
        <div class="filters-to">
          {{'' | i18n: 'to'}}
        </div>
        <div class="dates-box pl-0">
          <div class="filter-item-date" style="padding-left: 5%;">
            <select #select [(ngModel)]="age3to" (change)="selectAge()">
              <option value="null">{{'' | i18n: 'select'}}</option>
              @for (dealer of range; track dealer) {
                <option value={{dealer}}>{{dealer}}</option>
              }
            </select>
          </div>
        </div>

      </div>
    </div>
    <div class="col-3 pl-5 ml-0">

    </div>
    <div class="col-1 pl-0 ml-0">
      <div class="page-container mr-0">
        <button id="removePage" (click)="changePage(-1)" class="button button-page"
          [disabled]="this.filter.page == 0"><img alt="" src="assets/images/BMW-previous-144.png" width="20px"
        height="20px"></button>
        <div class="page-text-container"> {{ filter.page + 1 }} </div>
        <button id="addPage" (click)="changePage(1)" class="button button-page" [disabled]="this.datalength < 10">
          <img alt="" src="assets/images/BMW-next-144.png" width="20px" height="20px">
        </button>
      </div>
    </div>
  </div>
</div>

<div class="table-container">
  <table>
    <thead>
      <tr>
        <th><a (click)="orderBy('dealerName')">{{'' | i18n: 'dealer-name'}}@if (filter.orderBy == 'dealerName') {
          <img
            src="{{showDirectionImage()}}" alt=""
            class="sort-img"/>
        }</a></th>
        <th><a (click)="orderBy('dealerNumber')">{{'' | i18n: 'dealer-number'}}@if (filter.orderBy == 'dealerNumber') {
          <img
            src="{{showDirectionImage()}}" alt="" class="sort-img"/>
        }</a></th>
        <th>{{'' | i18n: 'contract-registration-year'}}</th>
        <th>{{'' | i18n: 'contract-registration-month'}}</th>
        <th style="width:110px "> {{'' | i18n: 'vehicle-age'}}</th>
        <th style="width:100px ">{{'' | i18n: 'vehicle-age'}}</th>
        <th style="width:100px ">{{'' | i18n: 'vehicle-age'}}</th>

      </tr>
      <tr>
        <th><a (click)="orderBy('dealerName')"></a></th>
        <th><a (click)="orderBy('dealerNumber')"></a></th>
        <th></th>
        <th></th>
        <th style="width:110px "><a (click)="orderBy('ageGroupOneCount')">{{age1from}}-{{age1to}}@if (filter.orderBy == 'ageGroupOneCount') {
          <img
            src="{{showDirectionImage()}}" alt=""
            class="sort-img"/>
        }</a></th>
        <th style="width:100px "><a (click)="orderBy('ageGroupTwoCount')">{{age2from}}-{{age2to}}</a></th>
        <th style="width:100px "><a (click)="orderBy('ageGroupThreeCount')">{{age3from}}-{{age3to}}</a></th>

      </tr>
    </thead>
    <tbody>
      @for (a of ageList; track a) {
        <tr>
          <td>{{ a.dealerName }}</td>
          <td>{{ a.dealerNumber }}</td>
          <td>{{ a.dateYear }}</td>
          <td>{{ a.dateMonth }}</td>
          <td>{{ a.ageGroupOneCount }}</td>
          <td>{{ a.ageGroupTwoCount }}</td>
          <td>{{ a.ageGroupThreeCount }}</td>
        </tr>
      }
    </tbody>
  </table>
</div>
</div>
